import React from "react";
import classes from "./PercentageStatDisplay.module.css";
const PercentageStatDisplay = ({
  percentage = null,
}) => {
  return (
    <div className="flex_1rem_gap">
      <div className={classes.wrapper} style={{ background: percentage < 0 ? "var(--dangerous2)" : "var(--honey-dew)" }}>
        <p className={classes.value} style={{ color: percentage < 0 ? "var(--error-color)" : "var(--medium-aquamarine)" }}>
          {percentage}%
        </p>
      </div>
      <p className={classes.strip}>Since the last month</p>
    </div>
  );
};

export default PercentageStatDisplay;
